import { appConfig } from "../config"
/**
 * Форматирует url (добавляет базовый url)
 * @param value Исходное значение
 * @returns Форматированное значение
 */
export default function urlFilter(value: any) {
  if (!value)
  	return;
  if (value.trim() === "" || value.length <= 4 || value.startsWith("http"))
    return value;
  const baseUrl = appConfig.apiUrl || "/";
  return value.startsWith("/") ? baseUrl + value.substring(1) : baseUrl + value;
}